import React, { useState } from 'react';
import useCheckResize from './use_check_resize';
import { isMobile } from 'react-device-detect';
var useClosePopoverAfterScrollOrZoom = (open, setOpen, inputRef) => {
  var _window;
  var supportsEvents = typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined';
  var [scrollPosition, setScrollPosition] = React.useState(supportsEvents ? (_window = window) === null || _window === void 0 ? void 0 : _window.scrollY : 0);
  var checkResize = useCheckResize();
  var [previousCheckResize, setPreviousCheckResize] = useState(checkResize);
  var closeAndBlurElement = React.useCallback(() => {
    var _inputRef$current;
    setOpen(false);
    inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
    if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) instanceof HTMLDivElement) {
      var _inputRef$current2;
      var focusableElements = inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.querySelectorAll('input, textarea, select, button');
      focusableElements === null || focusableElements === void 0 || focusableElements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.blur();
        }
      });
    }
  }, [inputRef, setOpen]);
  React.useEffect(() => {
    var scrollEvent = () => {
      var _window2, _window3;
      if (scrollPosition != ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) && open && !isMobile) {
        closeAndBlurElement();
      }
      setScrollPosition((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.scrollY);
    };
    if (supportsEvents) {
      var _window4;
      (_window4 = window) === null || _window4 === void 0 || _window4.addEventListener('scroll', scrollEvent);
    }
    return () => {
      var _window5;
      (_window5 = window) === null || _window5 === void 0 || _window5.removeEventListener('scroll', scrollEvent);
    };
  }, [closeAndBlurElement, open, scrollPosition, supportsEvents]);
  React.useEffect(() => {
    if (checkResize != previousCheckResize && !isMobile) {
      if (open) {
        closeAndBlurElement();
      }
      setPreviousCheckResize(checkResize);
    }
  }, [checkResize, closeAndBlurElement, open, previousCheckResize]);
};
export default useClosePopoverAfterScrollOrZoom;